<template>
  <MultiSelect
    :label="$i18n('cortina_marketings.index.perfis')"
    :campos="campos"
    :filtro="filtro"
    :filtro_id="filtro.filtro"
    :path="path"
    @atualizar="onAtualizar"
  />
</template>
<script>
import { computed, getCurrentInstance, toRef } from 'vue';
import MultiSelect from '../../components/MultiSelect.vue';
import { useFiltroMultiSelect } from '../../composables/useFiltroMultiSelect';

const PERFIS_IDS = ['recorrente', 'degustacao', 'maino_flex', 'despachante', 'lista'];

export default {
  components: { MultiSelect },
  props: {
    filtro: { type: Object, required: true },
    path: { type: String, required: true },
  },
  setup(props) {
    const { proxy } = getCurrentInstance();

    const campos = computed(() =>
      PERFIS_IDS.map(id => ({
        id,
        name: proxy.$i18n(`cortina_marketings.perfis.${id}`),
      }))
    );

    const { onAtualizar } = useFiltroMultiSelect({
      filtro: toRef(props, 'filtro'),
      path: toRef(props, 'path'),
    });

    return { campos, onAtualizar };
  },
}
</script>
